import React, { useState, useEffect } from 'react'
// import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import firebase from 'firebase/app';

import {LightningBoltIcon,} from '@heroicons/react/outline';

import BuySubscriptionTeam from './Dialog/BuySubscription';
import { handleChangeToTeam } from '../settingsPage/components/teamToken/functions/ChangeTokens';

function ShowTokensTeam({ auth, subscriptions, profile, adminData, tokens}) {

    const [ openModal, setOpenModal ] = useState(false)
    const [ tokensTeam, setTokensTeam ] = useState()
    const [disabled, setDisabled] = useState()


  useEffect(() => {
    var isMounted = true;
    var sum = 0

    if((tokens === '' || tokens === undefined)){
        sum = 0
    } else {
        sum = Number(tokens?.totalTokens)
    }
    var db = firebase.firestore();

    subscriptions?.map(async sub => {
        //console.log(sub.product.id)
        if(sub.product.id === 'prod_J8mOeYfobPCbDq'){
          // monthly individual 250
            if(sub.metadata.tokensAdded === 'no'){
                await db.collection('customers')
                .doc(auth.uid)
                .collection('subscriptions')
                .doc(sub.id)
                .update({
                    metadata:{
                        tokensAdded: "yes",
                        tokens: 250,
                    }
                }).then(async () =>{
                    await db.collection('customers')
                    .doc(auth.uid)
                    .collection('tokens')
                    .doc(auth.uid)
                    .set({
                        totalTokens: sum + 250
                    })
                })
            }     
        } else if (sub.product.id === 'prod_J2oNKQwYiFu6a1'){
          // monthly individual 500 messages
            if(sub.metadata.tokensAdded === 'no'){
                await db.collection('customers')
                .doc(auth.uid)
                .collection('subscriptions')
                .doc(sub.id)
                .update({
                    metadata:{
                        tokensAdded: "yes",
                        tokens: 500,
                    }
                }).then(async () =>{
                    await db.collection('customers')
                    .doc(auth.uid)
                    .collection('tokens')
                    .doc(auth.uid)
                    .set({
                        totalTokens: sum + 500
                    })
                })
            }
        } else if (sub.product.id === 'prod_JrFT0AjiDq6Va1'){
          // team monthly 1250 messages
          if(sub.metadata.tokensAdded === 'no'){
              await db.collection('customers')
              .doc(auth.uid)
              .collection('subscriptions')
              .doc(sub.id)
              .update({
                  metadata:{
                      tokensAdded: "yes",
                      tokens: 1250,
                  }
              }).then(async () =>{
                  await db.collection('customers')
                  .doc(auth.uid)
                  .collection('tokens')
                  .doc(auth.uid)
                  .set({
                      totalTokens: sum + 1250
                  })
              }).then(() =>{
                  handleChangeToTeam(profile, auth)
              })
          }
      } else if (sub.product.id === 'prod_JrFUYOYziRkEYR'){
        // team monthly 2,500 messages
        if(sub.metadata.tokensAdded === 'no'){
            await db.collection('customers')
            .doc(auth.uid)
            .collection('subscriptions')
            .doc(sub.id)
            .update({
                metadata:{
                    tokensAdded: "yes",
                    tokens: 2500,
                }
            }).then(async () =>{
                await db.collection('customers')
                .doc(auth.uid)
                .collection('tokens')
                .doc(auth.uid)
                .set({
                    totalTokens: sum + 2500
                })
            }).then(() =>{
              handleChangeToTeam(profile, auth)
          })
        }
    } else if (sub.product.id === 'prod_JrFOqqiGdlX5K0'){
      // Annual individual 250 tokens
      if(sub.metadata.tokensAdded === 'no'){
          await db.collection('customers')
          .doc(auth.uid)
          .collection('subscriptions')
          .doc(sub.id)
          .update({
              metadata:{
                  tokensAdded: "yes",
                  tokens: 3000,
              }
          }).then(async () =>{
              await db.collection('customers')
              .doc(auth.uid)
              .collection('tokens')
              .doc(auth.uid)
              .set({
                  totalTokens: sum + 3000
              })
          })
      }
  } else if (sub.product.id === 'prod_JrFQCcm4mJFf5E'){
    // Annual Individual 600 tokens
    if(sub.metadata.tokensAdded === 'no'){
        await db.collection('customers')
        .doc(auth.uid)
        .collection('subscriptions')
        .doc(sub.id)
        .update({
            metadata:{
                tokensAdded: "yes",
                tokens: 7200,
            }
        }).then(async () =>{
            await db.collection('customers')
            .doc(auth.uid)
            .collection('tokens')
            .doc(auth.uid)
            .set({
                totalTokens: sum + 7200
            })
        })
    }
} else if (sub.product.id === 'prod_JrFRMAhvcDCKuK'){
  // Annual Team 1250 tokens
  if(sub.metadata.tokensAdded === 'no'){
      await db.collection('customers')
      .doc(auth.uid)
      .collection('subscriptions')
      .doc(sub.id)
      .update({
          metadata:{
              tokensAdded: "yes",
              tokens: 15000,
          }
      }).then(async () =>{
          await db.collection('customers')
          .doc(auth.uid)
          .collection('tokens')
          .doc(auth.uid)
          .set({
              totalTokens: sum + 15000
          })
      }).then(() =>{
          handleChangeToTeam(profile, auth)
      })
  }
} else if (sub.product.id === 'prod_JrFSweJG4pb0WC'){
// Annual Team 2500 tokens
if(sub.metadata.tokensAdded === 'no'){
    await db.collection('customers')
    .doc(auth.uid)
    .collection('subscriptions')
    .doc(sub.id)
    .update({
        metadata:{
            tokensAdded: "yes",
            tokens: 30000,
        }
    }).then(async () =>{
        await db.collection('customers')
        .doc(auth.uid)
        .collection('tokens')
        .doc(auth.uid)
        .set({
            totalTokens: sum + 30000
        })
    }).then(() =>{
      handleChangeToTeam(profile, auth)
  })
}
}                                                      
    })


    //var db = firebase.firestore();

    // async function fetchData() {
    //     await db.collection('customers')
    //               .doc(adminData?.[0].adminId)
    //               .collection('tokens')
    //               .doc(adminData?.[0].adminId)
    //               .get()
    //               .then((doc) => {
    //                 if (doc.exists) {
    //                     setTokensTeam(doc.data().totalTokens)
    //                 } else {
    //                     setTokensTeam(0) 
    //                 }
    //               }).catch((error) => {
    //                   console.log("Error getting document:", error);
    //               });
    //     }

    function fetchUpdatedData() {
        firebase.firestore()
          .collection('customers')
          .doc(adminData?.[0].adminId)
          .collection('tokens')
          .doc(adminData?.[0].adminId)
          .onSnapshot((doc) => {
            setTokensTeam(doc.data().totalTokens)
          }, (error) => {
              console.log(error);
          });
    }

    if(adminData?.[0].adminId !== undefined && adminData?.[0].teamToken === true && isMounted === true && auth){
      //fetchData();
      fetchUpdatedData();
    }else{
      setTokensTeam(0) 
    }

    if(adminData?.[0].adminId !== auth.uid && adminData?.[0].teamToken === true && auth){
      setDisabled(true)
    }

    return () => {
      //console.log("unmount");
      isMounted = false;
    };


  }, [adminData, auth, subscriptions, tokens, profile])

    return (
      <div>
        {openModal ?
        <BuySubscriptionTeam 
        setOpenModal={setOpenModal}
        openModal={openModal}
        auth={auth}
        profile={profile}
        />
        :
        null
        }
        
        <button
        disabled={disabled}
        onClick={() => setOpenModal(true)}
        >
          <div className="bg-gray-900 rounded-lg text-gray-400 p-4 absolute bottom-20 w-11/12">
            <div className="flex">
              {tokensTeam < 5 ? <LightningBoltIcon className="h-7 mr-2 text-red-500 animate-bounce"/> : <LightningBoltIcon className="h-7 mr-2 text-blue-500"/> }
              {/* <LightningBoltIcon className="h-5 mr-2"/>  */}
              <span className="mt-1">Team tokens: {tokensTeam}</span>
              {tokensTeam < 11 ?
              <div className="border-2 border-gray-500 rounded-full ml-4 px-2 ">
                Get More
              </div>
              :
              null
              }
            </div>
          </div>
        </button>
      </div>
    )
} 

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        profile: state.firebase.profile,
        tokens: state.firestore.ordered.tokens ? state.firestore.ordered.tokens[0] : {totalTokens: 0},
        subscriptions: state.firestore.ordered.subscriptions,
        adminData: state.firestore.ordered.adminData
    }
  }


export default compose(
    connect(mapStateToProps, null),
    firestoreConnect((props) => {
        if (!props.auth.uid) return []
        if (!props.profile.company) return []
        return [
          {
            collection : 'customers',
              doc: props.auth.uid,
              subcollections : [{ collection: 'tokens' }],
              storeAs : 'tokens',
          },
          {
            collection : 'customers',
              doc: props.auth.uid,
              subcollections : [{ collection: 'subscriptions' }],
              where: [
                ['status', '==', 'active']
              ],
              storeAs : 'subscriptions',
          },
          {
            collection: 'organizations',
            doc: props.profile.company,
            subcollections:[{ collection: "teamToken", doc: props.profile.company, }],
            storeAs: 'adminData',
          },
        ]
    })
  )(ShowTokensTeam)
